var exports = {
  "Nr": "CrosspostCommunityCard.module__card___aWExam",
  "Uo": "CrosspostCommunityCard.module__sheetCard___aWExam",
  "vK": "CrosspostCommunityCard.module__banner___aWExam",
  "_e": "CrosspostCommunityCard.module__bannerImage___aWExam",
  "Dw": "CrosspostCommunityCard.module__bannerScrim___aWExam",
  "Kk": "CrosspostCommunityCard.module__icon___aWExam",
  "rf": "CrosspostCommunityCard.module__body___aWExam",
  "$": "CrosspostCommunityCard.module__titleRow___aWExam",
  "fh": "CrosspostCommunityCard.module__nameText___aWExam",
  "h_": "CrosspostCommunityCard.module__description___aWExam",
  "qr": "CrosspostCommunityCard.module__footer___aWExam",
  "dJ": "CrosspostCommunityCard.module__stat___aWExam",
  "gW": "CrosspostCommunityCard.module__statDot___aWExam",
  "rR": "CrosspostCommunityCard.module__statDotOnline___aWExam" + " " + "CrosspostCommunityCard.module__statDot___aWExam",
  "rb": "CrosspostCommunityCard.module__statDotMembers___aWExam" + " " + "CrosspostCommunityCard.module__statDot___aWExam",
  "KA": "CrosspostCommunityCard.module__statText___aWExam",
  "lm": "CrosspostCommunityCard.module__notice___aWExam",
  "XI": "CrosspostCommunityCard.module__action___aWExam",
  "Lq": "CrosspostCommunityCard.module__loading___aWExam",
};

module.exports = exports;
